import React, { FC } from "react";
import {
  Container,
  StyledBackButton,
  StepTitle,
  IndicatorRoot,
} from "./StepsIndicator.styled";

interface StepsIndicatorProps {
  stepBack: () => void;
  step: number;
  width: string;
  title: string;
  isHideBack: boolean;
  isGrayed: boolean;
}

const StepsIndicator: FC<StepsIndicatorProps> = ({
  stepBack,
  step,
  width,
  title,
  isHideBack,
  isGrayed,
}) => {
  return (
    <Container>
      {step !== 1 && step !== 5 && !isHideBack && (
        <StyledBackButton onClick={stepBack}>
          Back to Previous Step
        </StyledBackButton>
      )}
      <StepTitle isGrayed={isGrayed}>
        Step {step}: {title}
      </StepTitle>
      <IndicatorRoot width={width} />
    </Container>
  );
};

export default StepsIndicator;
